import React from 'react';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { BiErrorCircle } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Unauthorized = () => {

    return (
        <Container>
            <Row className="justify-content-center d-flex align-items-center mh-100vh">
                <Col md={6} xl={4}>
                    <Alert variant="danger" className="text-center p-2 pt-3">
                        <Alert.Heading>
                            <BiErrorCircle size={36} /> <br /> Unauthorized Access
                        </Alert.Heading>
                        <p>
                            You are not authorized to access this resource<br />
                            Click here to <Link to={appRoutesUrls.login()}><b>Login</b></Link> again.
                        </p>
                    </Alert>
                </Col>
            </Row>
        </Container>
    )
}

export default Unauthorized;